import React from "react";
import { HomeUninstallCard } from "./HomeUninstallCard";

export const DeactivationComplete = () => (
  <HomeUninstallCard
    title="Your deactivation request is being processed"
    description="It may take up to a few hours to process your deactivation request. Please note that your coworkers will still be able to invite you to Clockwise meetings unless you ask them to turn off Clockwise for those specific calendar events."
  />
);
